/**
 * Statusband bovenin een pane (review §4.3).
 *
 * Voor alles wat de gebruiker moet weten VOORDAT hij klikt: klaar om te starten,
 * ontbrekende inrichting, een waarschuwing, een lopende run, de laatste uitkomst.
 * Compact -- één regel met eventueel een tweede -- en met een vaste plek rechts
 * voor een icoon of een knop (opnieuw scannen, sluiten).
 */

import * as React from "react";
import "./pane.css";

export type StatusTone = "ok" | "warning" | "error" | "info" | "busy" | "neutral";

export interface StatusBandProps {
  tone?: StatusTone;
  /** Vetgedrukte eerste regel. */
  title?: React.ReactNode;
  /** Toelichting onder de titel, of de hele inhoud als er geen titel is. */
  children?: React.ReactNode;
  /** Rechts: icoon, knop of teller. */
  aside?: React.ReactNode;
  /** Klikbaar maken, bijvoorbeeld om details uit te klappen. */
  onClick?: () => void;
  className?: string;
  role?: string;
}

export function StatusBand({
  tone = "neutral",
  title,
  children,
  aside,
  onClick,
  className,
  role,
}: StatusBandProps): JSX.Element {
  const toneClass = tone === "neutral" ? "" : ` pane-status--${tone}`;
  return (
    <div
      className={`pane-status${toneClass}${className ? ` ${className}` : ""}`}
      role={role ?? (tone === "error" ? "alert" : "status")}
      onClick={onClick}
      style={onClick ? { cursor: "pointer" } : undefined}
    >
      <div className="pane-status__body">
        {title ? <div className="pane-status__title">{title}</div> : null}
        {children ? <div>{children}</div> : null}
      </div>
      {aside ? (
        <div className="pane-status__aside" onClick={(e) => e.stopPropagation()}>
          {aside}
        </div>
      ) : null}
    </div>
  );
}
